import React from 'react'
import { css } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import { Role, RoleSwitch } from '../roles'
import { CompliancePolicy } from './shared'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { WithTooltip, tooltipTitleCss } from '../../design-system'
import { CsWarningIcon } from '../../legacy-design-system/icons'
import { getCompliancePolicyEditRoute } from '../route'
import { Placement } from '@popperjs/core'
import { Link } from '@contrast-security-inc/design-system-typography'

const tooltipLinkCss = css`
  color: ${theme.color.turquoise50} !important;
`

const violationIconCss = css`
  color: ${theme.color.red50};
`

const tooltipContainerCss = css`
  max-width: 200px;
`

interface Props {
  readonly organizationID: string
  readonly organizationRole: Role
  readonly violatedCompliancePolicies: CompliancePolicy[]
  readonly tooltipPlacement?: Placement
}

export function TooltipContent({
  organizationID,
  organizationRole,
  violatedCompliancePolicies
}: Props) {
  return (
    <div className={tooltipContainerCss}>
      <FormattedMessage id="title_attention" defaultMessage="Attention">
        {(title) => <div className={tooltipTitleCss}>{title}</div>}
      </FormattedMessage>
      <FormattedMessage
        id="detail_compliancePolicyApplicationViolation_violationOfPoliciesSet"
        defaultMessage="This application is in violation of the following policies set by your administrator"
      >
        {(text) => <div>{text}</div>}
      </FormattedMessage>
      <RoleSwitch
        requiredRole="RULES_ADMIN"
        role={organizationRole}
        renderAllowed={() => {
          return violatedCompliancePolicies.map(({ id, name }, index) => (
            <React.Fragment key={id}>
              {!!index && ', '}
              <Link
                className={tooltipLinkCss}
                href={getCompliancePolicyEditRoute(organizationID, id)}
              >
                {name}
              </Link>
            </React.Fragment>
          ))
        }}
        renderDenied={() => {
          return violatedCompliancePolicies.map(({ id, name }, index) => (
            <span key={id}>
              {!!index && ', '}
              {name}
            </span>
          ))
        }}
      />
    </div>
  )
}

export function ViolationIndicator(props: Props) {
  return (
    <WithTooltip
      placement={props.tooltipPlacement || 'right'}
      children={() => {
        return <CsWarningIcon className={violationIconCss} size="16" />
      }}
      renderTooltipContent={() => {
        return <TooltipContent {...props} />
      }}
    />
  )
}
